import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Textarea } from '@fiverr-private/forms';
import { Counter } from '@fiverr-private/data_display';
import { theme } from '@fiverr-private/theme';
import { appTranslate } from '../../../i18n';
import { LIMITS } from '../../../../consts';
import type { WizardStepProps } from '../types';
import { answerField } from '../styles.ve.css';

type AppTranslateKey = Parameters<typeof appTranslate>[0];

interface FreeTextStepProps extends WizardStepProps {
    copyKey: string;
}

export const FreeTextStep = ({ copyKey, value, onChange }: FreeTextStepProps) => {
    const question = appTranslate(`${copyKey}.question` as AppTranslateKey);
    const subtext = appTranslate(`${copyKey}.subtext` as AppTranslateKey);
    const placeholder = appTranslate(`${copyKey}.placeholder` as AppTranslateKey);

    const showCounter = value.length >= LIMITS.answer - 100;

    return (
        <Stack direction="column" gap="12" width="100%">
            <Stack direction="column" gap="6" width="100%">
                {/* mobile heading (32px) */}
                <Typography
                    as="h2"
                    fontWeight="light"
                    color="white"
                    hidden={{ default: false, md: true }}
                    letterSpacing="-1.92px"
                    style={{ fontSize: '32px', lineHeight: 1.2 }}
                >
                    {question}
                </Typography>
                {/* desktop heading (54px) */}
                <Typography
                    as="h2"
                    fontWeight="light"
                    color="white"
                    hidden={{ default: true, md: false }}
                    letterSpacing="-2.7px"
                    style={{ fontSize: '54px', lineHeight: 1.1 }}
                >
                    {question}
                </Typography>
                {/* mobile subtext (18px) */}
                <Typography
                    as="p"
                    fontWeight="normal"
                    hidden={{ default: false, md: true }}
                    letterSpacing="-0.72px"
                    style={{ fontSize: '18px', lineHeight: 1.5, color: theme.colors.grey_700 }}
                >
                    {subtext}
                </Typography>
                {/* desktop subtext (24px) */}
                <Typography
                    as="p"
                    fontWeight="normal"
                    hidden={{ default: true, md: false }}
                    letterSpacing="-0.24px"
                    style={{ fontSize: '24px', lineHeight: 1.4, color: theme.colors.grey_700 }}
                >
                    {subtext}
                </Typography>
            </Stack>
            <Stack direction="column" gap="4" width="100%">
                <Textarea
                    className={answerField}
                    width="100%"
                    resize={false}
                    maxLength={LIMITS.answer}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    aria-label={question}
                />
                <Stack width="100%" justifyContent="flexEnd" style={{ visibility: showCounter ? 'visible' : 'hidden' }}>
                    <Typography as="span" style={{ fontSize: 14, color: theme.colors.grey_700 }}>
                        <Counter current={value.length} max={LIMITS.answer} />
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};
